<template>
  <b-dropdown
    v-if="dropDown"
    variant="link"
    no-caret
    toggle-class="p-0"
    right
  >
    <template #button-content>
      <b-badge
        pill
        variant="light-primary"
      >
        {{ activeDepartment.Title }}
        <slot />
      </b-badge>
    </template>
    <template
      v-for="itm in items"
    >
      <b-dropdown-item @click="item = itm.Id">
        {{ itm.Title }}
      </b-dropdown-item>
    </template>
  </b-dropdown>

  <v-select
    v-else
    v-model="item"
    dir="rtl"
    :multiple="multiple"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    :selectable="x => unselectable.includes(x.Id) === false || x === val"
    @open="onOpen"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  name: 'DepartmentSelect',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    dropDown: {
      type: Boolean,
      default: false,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  computed: {
    ...mapState('zirehState', { items: state => state.departmentSelect }),
    ...mapState('zirehState', { flag: state => state.departmentSelectFlag }),
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
    activeDepartment() {
      let selectedDepartment = []
      this.items.forEach(department => {
        if (department.Id === this.item) {
          selectedDepartment = department
        }
      })
      return selectedDepartment
    },
  },
  created() {
    this.get()
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setDepartmentSelectFlag', true)
        this.loading = true
        this.$http.post(
          this.$api.ticketdepartment.getall, {},
        )
          .then(res => {
            this.$store.commit('zirehState/setDepartmentSelect', res.data)
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
